import React, { useEffect, useRef, useState } from 'react';
import { Box, styled } from '@mui/material';

const AnimatedBox = styled(Box)(({ theme, animate, direction, delay }) => {
  const getInitialTransform = () => {
    switch (direction) {
      case 'left':
        return 'translateX(-100px)';
      case 'right':
        return 'translateX(100px)';
      case 'bottom':
        return 'translateY(100px)';
      case 'top':
        return 'translateY(-100px)';
      default:
        return 'translateY(50px)';
    }
  };

  return {
    opacity: animate ? 1 : 0,
    transform: animate ? 'translate(0, 0)' : getInitialTransform(),
    transition: `opacity 0.8s ease-out ${delay || 0}s, transform 0.8s ease-out ${delay || 0}s`,
  };
});

const AnimatedSection = ({ children, direction = 'bottom', delay = 0, threshold = 0.1 }) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          // Opcionalmente, dejar de observar después de la animación
          if (ref.current) {
            observer.unobserve(ref.current);
          }
        }
      },
      { threshold }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, [threshold]);

  return (
    <AnimatedBox ref={ref} animate={isVisible} direction={direction} delay={delay}>
      {children}
    </AnimatedBox>
  );
};

export default AnimatedSection;




